import { render } from "./ListUsers.vue?vue&type=template&id=3859dfbc&scoped=true"
import script from "./ListUsers.vue?vue&type=script&lang=js"
export * from "./ListUsers.vue?vue&type=script&lang=js"

import "./ListUsers.vue?vue&type=style&index=0&id=3859dfbc&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3859dfbc"]])

export default __exports__